import * as d3 from 'd3'
import Defs from '../../../../includes/primitives/colorDefs'

export default {
  methods: {

    set_LocalValues(){
      this.rawData = JSON.parse(JSON.stringify(this.DataItems))
      this.json = JSON.parse(JSON.stringify(this.JQueries))

      if (!this.rawData.length) {
        this.rawData = [{COMMENT: 'NO DATA IN COMMENT TABLE'}]
      }
    },
  }
}